















































































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { PaginationModel, VHeaders } from '@/models/pagedlistmodel';
import { Validator } from 'vee-validate';
import { Base } from '@/components/common/base';
import { ChatRules, TenantInfo } from '@/models/inventory/vehiclerevivestep';
import { Richtext } from 'dhx-richtext';
import 'dhx-richtext/codebase/richtext.css';
import { IDialogOption } from '@/models/dialog';
import { formSubmit } from '@servicestack/client';
import { LoginModel } from '@/models/admin/users';
import * as marked from 'marked';
import * as dhx from 'dhx-richtext';
import { storeService, vehicleReconStepService } from '@/shared';

@Component({
  props: ['methodName'],
  components: {
    Grid: () => import('@/components/common/app.grid.vue'),
    AppDialog: () => import('@/components/common/app.dialog.vue'),
    Richtext,
  },
  computed: {
    previewText() {
      return marked(this.md_text);
    },
    methodtoCall: {
      get() {
        return this.$props.methodName;
      },
    },
  },
})
export default class EditChatGptInstruction extends Base {

  public $validator: Validator;
  public loading: boolean = false;
  public pagination = new PaginationModel('createdAt', true, 5);
  // public actions: any[] = [];
  public items: any[] = [];
  public dialog: boolean;
  public instructionTextToDisplay: string = '';
  public recordKey: string;
  public instructionText: string = '';
  public instructionId: string = '';
  public storeId: number = 0;
  public tenantId: number = 0;
  public enterpriseId: number = 0;
  public html: string = '';
  public disableSaveInstruction: boolean = false;

  public css: string = '';
  public mode: { type: string; default: 'classic' };
  public value: string = '';

  public dataType: { type: string; default: 'markdown' };
  public richtext: Richtext;
  public markdown: string = '';
  public isDefaultTemplate: boolean = false;
  public isEnabled: boolean = false;
  public ruleOrder: number = 0;

  public conditionItems: any[] = [
    { value: 'EQUALSTO', text: 'Equals To' },
    { value: 'NOTEQUALSTO', text: 'Not Equals To' },
    { value: 'CONTAINS', text: 'Contains' },
    { value: 'GREATERTHAN', text: 'Greater Than' },
    { value: 'LESSTHAN', text: 'Less Than' },
  ];
  public rulesNameLoading: boolean = false;

  public rulesNameItems: any[] = [];

  public rules: any[] = [];
  public rulesValue: ChatRules;
  public showRulesSection: boolean = false;
  public rulesModel: any[] = [];
  public tenantInfo: TenantInfo = {
    tenantId: 0,
    enterpriseId: 0,
    storeId: 0,
  };

  public beforeDestroy() {
    const buttons = [];
    this.$emit('updateToolBar', buttons);
  }
  public callMethod(methodName): void {
    if (methodName === 'backToList') {
      if (history.state && history.length > 1) {
        history.back();
      }
    }
    this.resetMethodName(methodName);
  }
  public resetMethodName(methodName): void {
    if (methodName !== '') {
      this.$emit('resetMethodName', methodName);
    }
  }
  public updateToolBar(): void {
    const buttons: any = [];
    buttons.push({
      id: '0',
      type: 'button',
      title: "Back",
      disabled: false,
      visible: true,
      class: 'btn',
      label: "Back",
      click: 'backToList',
      icon: 'fas fa-arrow-left',
    });
    this.$emit('updateToolBar', buttons);
  }

  public created() {
    dhx.i18n.setLocale('richtext', this.$t('richText'));
    this.getChatGptRules();
  }

  public async mounted() {
    //this.setActions();
    this.richtext = new Richtext(this.$refs.container, {
      mode: this.mode,
      css: this.css,
    });

    this.storeId = Number(this.$route.params.storeId);
    this.instructionId = this.$route.params.id;

    this.updateToolBar();
    this.$watch('methodtoCall', (newVal, oldVal) => {
      if (newVal) {
        this.callMethod(newVal);
      }
    });

    const instruction = await storeService.getChatGptInstructionById(this.storeId, this.instructionId);
    this.isDefaultTemplate = instruction.isDefaultTemplate;
    this.ruleOrder = instruction.order;
    this.isEnabled = instruction.isEnabled;
    this.rules = instruction.rules;
    if (this.rules != undefined && this.rules.length > 0) {
      this.rules = this.rules.map(obj => {
        return {
          condition: obj.condition,
          name: obj.name,
          value: obj.value,
          ruleModel: {
            ruleName: obj.name
          }
        };
      });
    }
    this.richtext.setValue(instruction.template, this.mode);
    this.ToggleRuleSection();
  }


  public async saveInstruction(): Promise<void> {
    try {
      if (!this.isDefaultTemplate) {
        if (this.rules.length == 0) {
          this.showAlert(
            false,
            'Please enter atleast one rule for non default template'
          );
          return;
        }
        if (!(await this.validateFormByScope('ruleScope'))) {
          return;
        }

      }

      this.instructionText = this.richtext.getValue('markdown');
      if (!this.instructionText) {
        this.showAlert(
          false,
          'Instruction is empty'
        );
        return;
      }
      this.disableSaveInstruction = true;

      if (!this.$route.params.storeId) {
        this.showAlert(
          false,
          'Store Not found'
        );
        return;
      }
      if (this.rules.length > 0) {
        this.rules = this.rules.map(obj => {
        return {
          condition: obj.condition,
          name: obj.ruleModel.ruleName,
          value: obj.value,
          ruleModel: {
            ruleName: obj.ruleModel.ruleName
          }
        };
      });
      }
      if (this.isDefaultTemplate) {
        this.rulesModel = [];
      }
      this.storeId = Number(this.$route.params.storeId);
      await storeService.updateChatGptInstruction(
        this.storeId,
        this.instructionId,
        this.instructionText,
        this.ruleOrder,
        this.isDefaultTemplate,
        this.isEnabled,
        this.rules
      );

      this.instructionText = '';
      this.markdown = '';
      this.richtext.setValue(this.markdown, this.dataType);

      //this.(this.recordKey);
      this.showAlert(true, 'ChatGPT instruction updated successfully');
      if (history.state && history.length > 1) {
        history.back();
      }
      // this.$validator.reset();
    } finally {
      this.disableSaveInstruction = false;
    }
  }

  public updatePaging(paging: any) {
    this.pagination = paging;
  }

  public addRowToTable() {
    this.rules.push({
      name: '',
      condition: '',
      value: '',
      ruleModel: null,
      enabled: true
    });
  }

  public removeLineItems(model): void {
    const index = this.rules.indexOf(model);
    if (index > -1) {
      this.rules.splice(index, 1);
    }
  }

  public async getChatGptRules(): Promise<void> {
    try {
      this.rulesNameLoading = true;
      const response = await storeService.getChatGptvehicleRules();
      this.rulesNameItems = response.results;
    } finally {
      this.rulesNameLoading = false;
    }
  }

  public ToggleRuleSection(){
    if(this.isDefaultTemplate){
    this.showRulesSection = false;
    }else{
      this.showRulesSection = true;
    }
  }

}
